import { ApiClient } from '../apiClient';
import { CashbackEntry, CashbackProgram } from '../../types/cashback';
import { PaginationDto } from '../../types/pagination';

export class CashbackService {
  constructor(private apiClient: ApiClient) {}

  async getProgram(): Promise<CashbackProgram> {
    return this.apiClient.get<CashbackProgram>('/user/cashback/program');
  }

  // PENDING cashbacks only - CREDITED ones appear in the balance ledger
  // history via the CASHBACK type, so we don't double-surface them here.
  async getMyPending(
    page = 0,
    limit = 25,
  ): Promise<PaginationDto<CashbackEntry>> {
    return this.apiClient.post<PaginationDto<CashbackEntry>>(
      '/user/cashback/pending',
      {
        page,
        limit,
        sortBy: { maturityDate: 1 },
      },
    );
  }

  async getMyPendingTotalCents(): Promise<{ totalCents: number }> {
    return this.apiClient.get<{ totalCents: number }>(
      '/user/cashback/pending/total',
    );
  }
}
